// Primary & Secondary Brand colours
// Brand Colors / Yamaha ‘Feel’ Red / Primary
export const colorBrandYamahaRed = '#D52B1E';
// Brand Colors / Yamaha ‘Race’ Blue / Primary
export const colorBrandYamahaBlue = '#0A2D82';
// Brand Colors / Yamaha ‘Move’ Grey / Primary
export const colorBrandYamahaGrey = '#BCBDBC';
// Brand Colors / Yamaha ‘Move’ Metal / Primary
export const colorBrandYamahaMetal = '#6F7580';
// Brand Colors / Golf Green / Secondary
export const colorBrandGolfGreen = '#14AB06'; // TODO: (D.K.) Wrong desc! (Desc = #71AB59); Need clarify!
// Black group
export const colorCoreBlack1000 = '#000000'; // TODO: (D.K.) Issue with design
export const colorCoreBlack900Base = '#121212';
export const colorCoreBlack700 = '#2E2E2E';
export const colorCoreBlack500 = '#424242';
export const colorCoreBlack300 = '#5B5B5B';
export const colorCoreBlack200 = '#6D6D6D';
export const colorCoreBlack100 = '#808080';
// Gray group
export const colorCoreGray1000Base = '#929292';
export const colorCoreGray800 = '#B6B6B6';
export const colorCoreGray700 = '#C8C8C8';
export const colorCoreGray600 = '#D1D1D1';
export const colorCoreGray500 = '#DBDBDB';
export const colorCoreGray400 = '#E6E6E6';
export const colorCoreGray300 = '#F2F2F2';
export const colorCoreGray200 = '#FAFAFA';
export const colorCoreGray100 = '#FFFFFF';
// Error group
export const colorAccentError900 = '#B8251A';
export const colorAccentError800Base = '#D52B1E';
export const colorAccentError700 = '#E34338';
export const colorAccentError600 = '#E76359';
export const colorAccentError100 = '#FDEFEE';
// Alert group
export const colorAccentAlert900 = '#C73800'; // TODO: (D.K.) Wrong desc! (Desc = #AD4E00); Need clarify
export const colorAccentAlert700Base = '#FA8C16';
export const colorAccentAlert100 = '#FFF8E8';
// Success group
export const colorAccentSuccess800 = '#237804';
export const colorAccentSuccess700Base = '#389E0D';
export const colorAccentSuccess500 = '#73D13D';
export const colorAccentSuccess200 = '#D9F7BE';
export const colorAccentSuccess100 = '#F0FFE3';
// Info group
export const colorAccentInfo900Base = '#495AD7'; // TODO: (D.K.) Wrong desc! (Desc = #003A8C); Need clarify
export const colorAccentInfo200 = '#EFF1FF'; // TODO: (D.K.) Wrong desc! (Desc = #BAE7FF); Need clarify
export const colorAccentInfo100 = '#F8F9FF'; // TODO: (D.K.) Wrong desc! (Desc = #E6F7FF); Need clarify
export const defaultTransparent = 'transparent';
export const defaultInherit = 'inherit';
// White Transparent (with opacity)
export const colorWhiteTransparent900 = 'rgba(255, 255, 255, 0.9)';
export const colorWhiteTransparent800 = 'rgba(255, 255, 255, 0.8)';
export const colorWhiteTransparent600 = 'rgba(255, 255, 255, 0.6)';
export const colorWhiteTransparent500 = 'rgba(255, 255, 255, 0.5)';
export const colorWhiteTransparent400 = 'rgba(255, 255, 255, 0.4)';
export const colorWhiteTransparent300 = 'rgba(255, 255, 255, 0.3)';
export const colorWhiteTransparent200 = 'rgba(255, 255, 255, 0.2)';
export const colorWhiteTransparent100 = 'rgba(255, 255, 255, 0.1)';
// TODO: (D.K.) Need update this name and value for color (still clarifying)
export const colorWhiteTransparent000000 = 'rgba(255, 255, 255, 0)';
// Black Transparent (with opacity)
export const colorBlackTransparent900 = 'rgba(0, 0, 0, 0.9)';
export const colorBlackTransparent800 = 'rgba(0, 0, 0, 0.8)';
export const colorBlackTransparent600 = 'rgba(0, 0, 0, 0.6)';
export const colorBlackTransparent500 = 'rgba(0, 0, 0, 0.5)';
export const colorBlackTransparent400 = 'rgba(0, 0, 0, 0.4)';
export const colorBlackTransparent300 = 'rgba(0, 0, 0, 0.3)';
export const colorBlackTransparent200 = 'rgba(0, 0, 0, 0.2)';
export const colorBlackTransparent100 = 'rgba(0, 0, 0, 0.1)';
export const colorBlackTransparent50 = 'rgba(0, 0, 0, 0.05)';
export const colorBlackTransparent0 = 'rgba(0, 0, 0, 0.0)';
// Link
export const colorAccentLinkLight = '#0F62FE';
// White
export const colorCoreWhite1000 = '#FFFFFF';
// Background
export const colorCoreBackground1000 = '#F7F7F5';
export const hexColorBlackTransparent50 = '#EBEBE9';
export const separatorBackGroundColor = '#C4C4C4';
export const socialIconBackgroundColor = '#333333';
// Extra/Specific colors
export const extraGrayColor = 'rgba(91, 91, 91, 1)';
export const extraSecondGrayColor = 'rgba(219, 219, 219, 1)';
export const greenSustainableColor = 'rgba(56, 158, 13, 1)';
export const defaultOutlineColor = 'rgb(0, 95, 204)';
// Gradients (Race / Move / Feel)
// Gradients are used sparingly within backgrounds.
// They run from ‘dark’ to ‘light’ and use the primary colours of blue, red and grey.
// YME ‘Feel’ Gradient (Red)
export const colorGradientYMERed = `
  linear-gradient(173.06deg, #F23F31 -2.4%, #D52B1E 51.11%, #BF1F12 77.57%, #AD0E02 97.72%)
`;
// YME ‘Race’ Gradient (Blue)
export const colorGradientYMEBlue = `
  linear-gradient(0deg, #092979 -12.47%, #0B2E82 47.99%, #1B3E91 92.81%)
`;
// YME ‘Move’ Gradient (Gray)
export const colorGradientYMEGrey = `
  linear-gradient(0deg, #6F7580 0%, #8B9099 50%, #9B9EA3 100%)
`;
// Custom gradients
export const customGradientFromWhiteToTransparent90deg = `
  linear-gradient(90deg, ${colorCoreWhite1000} 0%, ${colorWhiteTransparent000000} 100%)
`;
export const customGradientFromWhiteToTransparent270deg = `
  linear-gradient(270deg, ${colorCoreWhite1000} 0%, ${colorWhiteTransparent000000} 100%)
`;
export const HERO_SECTION_BACKGROUND_SECOND = `
  linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 100%), 
  linear-gradient(90deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0) 100%)
`;
export const BG_GRADIENT_FROM_TRANSPARENT_TO_BLACK = 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%)';
export const BG_GRADIENT_FROM_WHITE_TO_TRANSPARENT = `
  linear-gradient(180deg, #FFFFFF 19.43%, rgba(255, 255, 255, 0) 100%);
`;
export const BG_GRADIENT_PRODUCT_CARD = `linear-gradient(180deg, ${colorCoreWhite1000} 32.06%, rgba(255, 255, 255, 0) 81.95%),
  linear-gradient(180deg, ${colorCoreWhite1000} 32.06%, rgba(255, 255, 255, 0) 81.95%)`;
export const BG_GRADIENT_NEWSLETTER = 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.75) 100%), linear-gradient(90deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0.00) 100%)';
// Common shadow block for all text inside of Hero Section
export const FILTER_DROP_SHADOW_DEFAULT = 'drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.32))';
